import {createActions} from 'client/framework';

export default createActions(null, [
  'RESET_STORE',
  'SET_IS_VIEWING_STAGING_DETAILS',
  'SET_SELECTED_ACTIVE_SECTION_ID'
]);
